import { Config, CentralizedLogin as OriginalCentralizedLoginSDK } from '@foxcorp/foxkit-profile-js/centralized-login';

import { uiConfig } from '@/config/uiConfig';
import { configOptions } from '@/sdk/shared/profileOptions';

import { statefulRefreshToken } from './statefulRefreshToken';

export class CentralizedLogin extends OriginalCentralizedLoginSDK {
  public constructor(config: Config) {
    super(config);
  }

  override async onVisibilityChange(): Promise<void> {
    // noop
  }
}

const config = new Config({
  ...configOptions,

  clientId: uiConfig.clientId,
  redirectUri: uiConfig.callbackUrl,
  authBaseUrl: uiConfig.authUrl,
  environment: uiConfig.environmentAlt,

  statefulRefreshToken,
});

export const centralizedLogin = new CentralizedLogin(config);
